import { render, staticRenderFns } from "./AddProjectApplyDialog.vue?vue&type=template&id=53bf8ab8&scoped=true&"
import script from "./AddProjectApplyDialog.vue?vue&type=script&lang=js&"
export * from "./AddProjectApplyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf8ab8",
  null
  
)

export default component.exports